<header
	class="px-4 py-3 bg-fx-gradient-8 border-b border-fx-grey-600 flex justify-center sticky top-0 z-10"
>
	<div class="text-sm mr-2 sm:mr-4">
		<span class="text-fx-gradient-4"
			>Trade and Earn upto <span class="font-bold text-base"
				>1 Million points</span
			>
			daily. Polynomial Trade 2.0 is live with cross margin and one click trading. </span
		>
		<a
			class="font-medium ml-1 bg-fx-grey-900 border border-fx-grey-500 px-3 py-1 rounded-2xl border-px text-fx-grey-100"
			href="https://polynomial.fi/trade"
			target="_blank">Trade Now</a
		>
	</div>
</header>
